import { Component,
         OnInit }           from '@angular/core';
import { FormGroup,
         FormBuilder,
         Validators }       from '@angular/forms';
import { CustomValidators } from 'ng2-validation';

import { AuthService }      from 'ng2-ui-auth';
import { Router }           from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading: boolean;

  constructor(
    fb: FormBuilder,
    private auth: AuthService,
    private router: Router
  ) {
    this.loading = false;

    this.loginForm = fb.group({
      'email': [null, Validators.compose([Validators.required, CustomValidators.email])],
      'password': [null, Validators.required]
    });
  }

  submitForm($ev, form: FormGroup) {
    $ev.preventDefault();
    let value = form.value;
    for (let c in form.controls) {
      form.controls[c].markAsTouched();
    }
    if (form.valid) {
      this.loading = true;

      setTimeout(() => {
        $('.loader-inner').loaders();

        this.auth.login({
          data: value
        })
        .subscribe(
          data  => console.info('Login'),
          error => {
            this.loading = false;
            console.error(error);
          },
          ()    => this.router.navigateByUrl('dashboard')
        );
      });
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/user/login/login.component.ts